
(function(){
  'use strict';
  const legalKinds=['impressum','datenschutz','versand','retoure','agb'];
  const legalTitle={impressum:'IMPRESSUM.',datenschutz:'DATENSCHUTZ.',versand:'VERSAND.',retoure:'RÜCKGABE.',agb:'AGB.'};
  const q=id=>document.getElementById(id);
  let prevFocus=null,restoreHash='';
  let navToken=0,navFrame=0,navFallback=0;
  const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
  // Hide only the cloud title during a button-controlled journey.
  // Manual wheel/touch/keyboard scrolling keeps the original title animation.
  function endNavigationScroll(){
    navToken++;
    if(navFrame)cancelAnimationFrame(navFrame);
    if(navFallback)clearTimeout(navFallback);
    navFrame=0;navFallback=0;
    window.BB_SILENCE_CLOUD_COPY=false;
    document.documentElement.classList.remove('bb-nav-jump');
  }
  function abortNavigationOnUserScroll(){
    if(document.documentElement.classList.contains('bb-nav-jump'))endNavigationScroll();
  }
  window.addEventListener('wheel',abortNavigationOnUserScroll,{passive:true});
  window.addEventListener('touchstart',abortNavigationOnUserScroll,{passive:true});
  window.addEventListener('keydown',event=>{
    if(['ArrowUp','ArrowDown','PageUp','PageDown','Home','End',' '].includes(event.key))abortNavigationOnUserScroll();
  },{passive:true});
  function legalVisible(){return !q('legalDialog').hidden;}
  function showLegal(kind,push=true){
    if(!legalKinds.includes(kind))return;
    if(!legalVisible()){restoreHash=location.hash||'#footer';prevFocus=document.activeElement;}
    q('legalBackdrop').hidden=false;
    q('legalDialog').hidden=false;
    q('legalDialog').setAttribute('aria-hidden','false');
    document.body.classList.add('is-locked');
    document.querySelectorAll('[data-legal-pane]').forEach(p=>p.hidden=p.dataset.legalPane!==kind);
    document.querySelectorAll('[data-legal]').forEach(b=>b.setAttribute('aria-selected',String(b.dataset.legal===kind)));
    q('legalTitle').textContent=legalTitle[kind];
    q('legalDialog').querySelector('.legal-scroll').scrollTop=0;
    if(push && location.hash!==('#'+kind))history.pushState({legal:kind},'', '#'+kind);
    q('closeLegal').focus({preventScroll:true});
  }
  function hideLegal(changeUrl=true){
    if(!legalVisible())return;
    q('legalDialog').hidden=true;
    q('legalBackdrop').hidden=true;
    q('legalDialog').setAttribute('aria-hidden','true');
    if(!q('productModal').classList.contains('is-open') && !q('cartDrawer').classList.contains('is-open') && !q('checkoutModal').classList.contains('is-open'))document.body.classList.remove('is-locked');
    if(changeUrl && legalKinds.includes(location.hash.slice(1)))history.replaceState({},'',restoreHash||'#footer');
    prevFocus?.focus?.({preventScroll:true});
  }
  function directJump(hash,updateHistory=true){
    const el=q(hash.slice(1));if(!el)return;
    if(legalVisible())hideLegal(false);
    endNavigationScroll();
    window.BB_SILENCE_CLOUD_COPY=true;
    document.documentElement.classList.add('bb-nav-jump');
    // Keep the native smooth scroll from the previous design, rather than jumping.
    const offset=hash==='#top'?0:Math.max(0,el.getBoundingClientRect().top+window.scrollY-77);
    const maxScroll=Math.max(0,document.documentElement.scrollHeight-window.innerHeight);
    const destination=Math.min(offset,maxScroll);
    const token=navToken;
    if(updateHistory && location.hash!==hash)history.pushState({nav:hash},'',hash);
    window.scrollTo({top:destination,behavior:reduceMotion.matches?'instant':'smooth'});
    if(reduceMotion.matches){
      navFrame=requestAnimationFrame(()=>{if(token===navToken)endNavigationScroll();});
      return;
    }
    // The title remains hidden for the *whole* animated journey, including when
    // scrolling upwards. Restore it only after the destination is reached.
    let settledFrames=0;
    const started=performance.now();
    function watchArrival(){
      if(token!==navToken)return;
      if(Math.abs(window.scrollY-destination)<=2)settledFrames++;
      else settledFrames=0;
      if(settledFrames>=3 || performance.now()-started>6800){
        endNavigationScroll();
      }else{
        navFrame=requestAnimationFrame(watchArrival);
      }
    }
    navFrame=requestAnimationFrame(watchArrival);
    // Safety net if a tab is suspended and requestAnimationFrame pauses.
    navFallback=setTimeout(()=>{if(token===navToken)endNavigationScroll();},7100);
  }
  document.addEventListener('click',e=>{
    const switcher=e.target.closest('button[data-legal]');
    if(switcher){e.preventDefault();showLegal(switcher.dataset.legal);return;}
    const a=e.target.closest('a[href^="#"]');
    if(!a)return;
    const hash=a.getAttribute('href');
    if(legalKinds.includes(hash.slice(1))){e.preventDefault();showLegal(hash.slice(1));return;}
    if(q(hash.slice(1))){e.preventDefault();directJump(hash);}
  });
  q('legalBackdrop').addEventListener('click',()=>hideLegal());
  q('closeLegal').addEventListener('click',()=>hideLegal());
  q('legalDone').addEventListener('click',()=>hideLegal());
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&legalVisible()){e.stopImmediatePropagation();hideLegal();}},true);
  window.addEventListener('popstate',()=>{
    const kind=location.hash.slice(1);
    if(legalKinds.includes(kind))showLegal(kind,false);
    else {
      if(legalVisible())hideLegal(false);
      if(q(kind))directJump('#'+kind,false);
    }
  });
  const productHelp=q('originalProductLink');
  productHelp.addEventListener('click',()=>{
    if(typeof closeProduct==='function')closeProduct();
    directJump('#contact');
  });
  const incoming=location.hash.slice(1);
  if(legalKinds.includes(incoming))setTimeout(()=>showLegal(incoming,false),80);
})();
